import { Pipe, PipeTransform } from '@angular/core';

/**
 * Converts a PascalCase string to a human-readable "Title Case With Spaces" string.
 * Examples:
 *   ResaveAll           → Resave All
 *   PublishedRecordId   → Published Record Id
 *   EHSAgent            → EHS Agent
 *   QA                  → QA
 */
@Pipe({ name: 'pascalToHuman', standalone: true })
export class PascalToHumanPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) return value;
        return value
            // Insert space between a lowercase/digit and an uppercase letter: "saveAll" → "save All"
            .replace(/([a-z\d])([A-Z])/g, '$1 $2')
            // Insert space between consecutive uppercase letters and the start of the next word: "EHSAgent" → "EHS Agent"
            .replace(/([A-Z])(?=[A-Z][a-z])/g, '$1 ')
            .trim();
    }
}

